// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","443":"about","548":"calendar","631":"contact","821":"pagina"}[chunkId] + "." + {"177":"58752bc7","443":"58752bc7","548":"58752bc7","631":"58752bc7","821":"58752bc7"}[chunkId] + ".css";
};